export default "__VITE_ASSET__871f35f9__"